import { render } from "./VideoCell.vue?vue&type=template&id=38e40094"
import script from "./VideoCell.vue?vue&type=script&lang=js"
export * from "./VideoCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__